// @generated by protoc-gen-connect-es v0.10.0 with parameter "target=ts"
// @generated from file src/protos/analysis_management/analysis.assessment.apis.proto (package geneo.analysis.school.assessment.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FetchAssessmentReportRequest, FetchAssessmentReportResponse, FetchAssessmentReportV2Request, FetchAssessmentReportV2Response, FetchConnectedClassroomAssessmentReportRequest, FetchConnectedClassroomAssessmentReportResponse, fetchKdtAssessmentStudentsDetailsRequest, fetchKdtAssessmentStudentsDetailsResponse, FetchOmrAssessmentReportV2Response, FetchOmrStudentAssessmentReportRequest, FetchOmrStudentAssessmentReportResponse, FetchStudentAssessmentReportV2Request, FetchStudentAssessmentReportV2Response, FetchStudentAssessmentReportV3Request, FetchStudentAssessmentReportV3Response, FetchStudentAssessmentSummaryReportRequest, FetchStudentAssessmentSummaryReportResponse, FetchStudentHwReportRequest, FetchStudentHwReportResponse, FetchStudentKdtAssessmentReportRequest, FetchStudentKdtAssessmentReportResonse, FetchStudentOMRKdtAssessmentReportRequest, FetchStudentsBulkAssessmentReportRequest, FetchStudentsBulkAssessmentReportResponse, FetchStudentsBulkAssessmentReportV3Request, FetchStudentsBulkAssessmentReportV3Response, GetBulkReportStatusRequest, GetBulkReportStatusResponse, ImportOmrResponsesRequest, ImportOmrResponsesResponse, InsertOmrResponsesRequest, InsertOmrResponsesResponse, KdtAssessmentSendMailRequest, KdtAssessmentSendMailResponse, updateAssessmentReportPDFRequest, updateAssessmentReportPDFResponse, updateAssessmentReportPDFV2Request, updateAssessmentReportPDFV2Response, UpdateConnectedClassroomReportPDFRequest, UpdateConnectedClassroomReportPdfResponse, updateKdtStudentAssessmentReportPdfRequest, updateKdtStudentAssessmentReportPdfResponse, updateStudentAssessmentReportPdfRequest, updateStudentAssessmentReportPdfResponse, updateStudentAssessmentReportPdfV2Request, updateStudentAssessmentReportPdfV2Response, updateStudentAssessmentSummaryReportPdfRequest, updateStudentAssessmentSummaryReportPdfResponse, updateStudentHwPdfResponse, updateStudentOMRKdtPdfRequest } from "./analysis.assessment.apis_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1
 */
export const SchoolAssessmentAPIServiceV1 = {
  typeName: "geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1",
  methods: {
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.fetchSchoolAssessmentReport
     */
    fetchSchoolAssessmentReport: {
      name: "fetchSchoolAssessmentReport",
      I: FetchAssessmentReportRequest,
      O: FetchAssessmentReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.updateAssessmentReportPdfRecord
     */
    updateAssessmentReportPdfRecord: {
      name: "updateAssessmentReportPdfRecord",
      I: updateAssessmentReportPDFRequest,
      O: updateAssessmentReportPDFResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.fetchConnectedClassroomAssessmentReport
     */
    fetchConnectedClassroomAssessmentReport: {
      name: "fetchConnectedClassroomAssessmentReport",
      I: FetchConnectedClassroomAssessmentReportRequest,
      O: FetchConnectedClassroomAssessmentReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.updateConnectedClassroomReportPDFRecord
     */
    updateConnectedClassroomReportPDFRecord: {
      name: "updateConnectedClassroomReportPDFRecord",
      I: UpdateConnectedClassroomReportPDFRequest,
      O: UpdateConnectedClassroomReportPdfResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.fetchStudentKdtAssessmentReport
     */
    fetchStudentKdtAssessmentReport: {
      name: "fetchStudentKdtAssessmentReport",
      I: FetchStudentKdtAssessmentReportRequest,
      O: FetchStudentKdtAssessmentReportResonse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.updateStudentKdtReportPDFRecord
     */
    updateStudentKdtReportPDFRecord: {
      name: "updateStudentKdtReportPDFRecord",
      I: updateKdtStudentAssessmentReportPdfRequest,
      O: updateKdtStudentAssessmentReportPdfResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.fetchKdtAssessmentStudentsDetails
     */
    fetchKdtAssessmentStudentsDetails: {
      name: "fetchKdtAssessmentStudentsDetails",
      I: fetchKdtAssessmentStudentsDetailsRequest,
      O: fetchKdtAssessmentStudentsDetailsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.sendKdtAssessmentEmailReport
     */
    sendKdtAssessmentEmailReport: {
      name: "sendKdtAssessmentEmailReport",
      I: KdtAssessmentSendMailRequest,
      O: KdtAssessmentSendMailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.fetchStudentHwReport
     */
    fetchStudentHwReport: {
      name: "fetchStudentHwReport",
      I: FetchStudentHwReportRequest,
      O: FetchStudentHwReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.updateStudentAssessmentReportPDFRecord
     */
    updateStudentAssessmentReportPDFRecord: {
      name: "updateStudentAssessmentReportPDFRecord",
      I: updateStudentAssessmentReportPdfRequest,
      O: updateStudentAssessmentReportPdfResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.fetchStudentOMRKdtAssessmentReport
     */
    fetchStudentOMRKdtAssessmentReport: {
      name: "fetchStudentOMRKdtAssessmentReport",
      I: FetchStudentOMRKdtAssessmentReportRequest,
      O: FetchStudentAssessmentReportV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.updateStudentOMRKdtHwGenPdfRow
     */
    updateStudentOMRKdtHwGenPdfRow: {
      name: "updateStudentOMRKdtHwGenPdfRow",
      I: updateStudentOMRKdtPdfRequest,
      O: updateStudentHwPdfResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.importOmrResponsesFromExcel
     */
    importOmrResponsesFromExcel: {
      name: "importOmrResponsesFromExcel",
      I: ImportOmrResponsesRequest,
      O: ImportOmrResponsesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.insertOmrResponses
     */
    insertOmrResponses: {
      name: "insertOmrResponses",
      I: InsertOmrResponsesRequest,
      O: InsertOmrResponsesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV1.fetchOmrStudentAssessmentReport
     */
    fetchOmrStudentAssessmentReport: {
      name: "fetchOmrStudentAssessmentReport",
      I: FetchOmrStudentAssessmentReportRequest,
      O: FetchOmrStudentAssessmentReportResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2
 */
export const SchoolAssessmentAPIServiceV2 = {
  typeName: "geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2",
  methods: {
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2.fetchSchoolAssessmentReport
     */
    fetchSchoolAssessmentReport: {
      name: "fetchSchoolAssessmentReport",
      I: FetchAssessmentReportV2Request,
      O: FetchAssessmentReportV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2.updateAssessmentReportPdfRecord
     */
    updateAssessmentReportPdfRecord: {
      name: "updateAssessmentReportPdfRecord",
      I: updateAssessmentReportPDFV2Request,
      O: updateAssessmentReportPDFV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2.fetchStudentAssessmentReport
     */
    fetchStudentAssessmentReport: {
      name: "fetchStudentAssessmentReport",
      I: FetchStudentAssessmentReportV2Request,
      O: FetchStudentAssessmentReportV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2.updateStudentAssessmentReportPDFRecord
     */
    updateStudentAssessmentReportPDFRecord: {
      name: "updateStudentAssessmentReportPDFRecord",
      I: updateStudentAssessmentReportPdfV2Request,
      O: updateStudentAssessmentReportPdfV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2.fetchStudentsAssessmentBulkReport
     */
    fetchStudentsAssessmentBulkReport: {
      name: "fetchStudentsAssessmentBulkReport",
      I: FetchStudentsBulkAssessmentReportRequest,
      O: FetchStudentsBulkAssessmentReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2.fetchStudentsOMRAssessmentBulkReport
     */
    fetchStudentsOMRAssessmentBulkReport: {
      name: "fetchStudentsOMRAssessmentBulkReport",
      I: FetchStudentsBulkAssessmentReportRequest,
      O: FetchStudentsBulkAssessmentReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2.getBulkReportStatus
     */
    getBulkReportStatus: {
      name: "getBulkReportStatus",
      I: GetBulkReportStatusRequest,
      O: GetBulkReportStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2.fetchStudentAssessmentSummaryReport
     */
    fetchStudentAssessmentSummaryReport: {
      name: "fetchStudentAssessmentSummaryReport",
      I: FetchStudentAssessmentSummaryReportRequest,
      O: FetchStudentAssessmentSummaryReportResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2.updateStudentAssessmentSummaryReportPDFRecord
     */
    updateStudentAssessmentSummaryReportPDFRecord: {
      name: "updateStudentAssessmentSummaryReportPDFRecord",
      I: updateStudentAssessmentSummaryReportPdfRequest,
      O: updateStudentAssessmentSummaryReportPdfResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2.fetchOmrTeacherAssessmentReport
     */
    fetchOmrTeacherAssessmentReport: {
      name: "fetchOmrTeacherAssessmentReport",
      I: FetchAssessmentReportV2Request,
      O: FetchOmrAssessmentReportV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV2.updateOmrTeacherAssessmentReportPdfRecord
     */
    updateOmrTeacherAssessmentReportPdfRecord: {
      name: "updateOmrTeacherAssessmentReportPdfRecord",
      I: updateAssessmentReportPDFV2Request,
      O: updateAssessmentReportPDFV2Response,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * @generated from service geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV3
 */
export const SchoolAssessmentAPIServiceV3 = {
  typeName: "geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV3",
  methods: {
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV3.fetchStudentAssessmentReport
     */
    fetchStudentAssessmentReport: {
      name: "fetchStudentAssessmentReport",
      I: FetchStudentAssessmentReportV3Request,
      O: FetchStudentAssessmentReportV3Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV3.fetchSchoolAssessmentReport
     */
    fetchSchoolAssessmentReport: {
      name: "fetchSchoolAssessmentReport",
      I: FetchAssessmentReportV2Request,
      O: FetchAssessmentReportV2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.analysis.school.assessment.apis.SchoolAssessmentAPIServiceV3.fetchStudentsAssessmentBulkReport
     */
    fetchStudentsAssessmentBulkReport: {
      name: "fetchStudentsAssessmentBulkReport",
      I: FetchStudentsBulkAssessmentReportV3Request,
      O: FetchStudentsBulkAssessmentReportV3Response,
      kind: MethodKind.Unary,
    },
  }
} as const;

